export default __webpack_public_path__ + "static/media/bulldozer_operator_job_hiring.4b7e2d51.png";